import Preloader from "../helper/Preloader";
import BrandSectionOne from "../components/BrandSectionOne";
import BreadcrumbNine from "../components/BreadcrumbNine";
import CartPayment from "../components/CartPayment";
import PayWIth from "../components/PayWIth";
import PayStatus from "../components/PayStatus";

const PaymentPage = ({ status }) => {
  let payStatuses = ["success", "failed", "pending"];

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* BreadcrumbNine */}
      <BreadcrumbNine />

      {/* Contact */}
      {status ? (
        status === "pay" ? (
          <PayWIth />
        ) : payStatuses.includes(status) ? (
          <PayStatus status={status} />
        ) : (
          <CartPayment />
          
        )
      ) : (
        <CartPayment />
      )}
    </>
  );
};

export default PaymentPage;
